import React, { useEffect, useState } from "react";
import ScoreItem from "../../../merchant/components/Chargeback/ScoreItem";
import SkeletonLoader from "../../../../components/skeleton-loader";
import style from "../../../merchant/components/Chargeback/ScoreCard.module.scss";
import { getChargebackScoreboard } from "../../../../../api";
import useChargebackStore from "../../../../stores/chargeback";
import useDomainStore from "../../../../stores/domain";
import moment from "moment";
import { toast } from "react-hot-toast";

function ChargebackScoreCard() {
  const { isKurvDomain } = useDomainStore();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    new: 0,
    new_amount: 0,
    pending: 0,
    pending_amount: 0,
    won: 0,
    won_amount: 0,
    loss: 0,
    loss_amount: 0,
    total: 0,
  });

  const filters = useChargebackStore((state) => state.filters);

  const defaultDateRange = {
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Use the dates directly from filters or default
        const params = {
          startDate: filters.dateRange?.startDate || defaultDateRange.startDate,
          endDate: filters.dateRange?.endDate || defaultDateRange.endDate,
        };

        const response = await getChargebackScoreboard(params);

        if (response?.status === true && response?.data) {
          setData(response.data);
        } else {
          toast.error("Failed to fetch scoreboard data");
          setData({
            new: 0,
            new_amount: 0,
            pending: 0,
            pending_amount: 0,
            won: 0,
            won_amount: 0,
            loss: 0,
            loss_amount: 0,
            total: 0,
          });
        }
      } catch (error) {
        toast.error("Error fetching chargeback scoreboard");
        setData({
          new: 0,
          new_amount: 0,
          pending: 0,
          pending_amount: 0,
          won: 0,
          won_amount: 0,
          loss: 0,
          loss_amount: 0,
          total: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filters.dateRange]);

  if (loading) {
    return (
      <div className={style.cb_score_card}>
        <div className={style.header}>
          <SkeletonLoader variant="rectangular" height={24} width={120} />
        </div>
        <div className={style.score_list}>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className={style.score_item}>
              <SkeletonLoader variant="rectangular" height={16} width={60} />
              <SkeletonLoader variant="rectangular" height={32} width="100%" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`${style.cb_score_card} ${isKurvDomain ? style.kurv_theme : ""}`}>
      <div className={style.header}>
        <h5>CB Scorecard</h5>
      </div>

      <div className={style.score_list}>
        <ScoreItem
          title="New"
          amount={data?.new_amount || 0}
          chargebacks={data?.new || 0}
          totalChargebacks={data?.total || 0}
          color="#4C70EF"
        />

        <ScoreItem
          title="Pending"
          amount={data?.pending_amount || 0}
          chargebacks={data?.pending || 0}
          totalChargebacks={data?.total || 0}
          color="#254FE2"
        />

        <ScoreItem
          title="Won"
          amount={data?.won_amount || 0}
          chargebacks={data?.won || 0}
          totalChargebacks={data?.total || 0}
          color="#37B450"
        />

        <ScoreItem
          title="Loss"
          amount={data?.loss_amount || 0}
          chargebacks={data?.loss || 0}
          totalChargebacks={data?.total || 0}
          color="#E03B24"
        />
      </div>
    </div>
  );
}

export default ChargebackScoreCard;
